const initState = () => {
  return [];
}

const offers = (state=initState(), action) => {
  switch (action.type) {

    case "INIT_OFFERS":
      return action.payload;

    default:
      return state;
  }
}

export default offers;
